export const CURRENCY_CODES = ["EUR", "KARMA"];
export const TAALY = "TAALY";
